import { request } from '@/shared/api/request'

export const sendOppv = (params) => {
	return request({ url: 'contract/oopv/send', method: 'POST', params })
}
